import { TinyDropDownOption } from '~components/common/TinyDropDown';
import { ValueOf } from '~types/common';

interface CompanyDetailMenus {
  id: ValueOf<typeof COMPANY_DETAIL_MENU>;
  text: string;
  isNew?: boolean;
}

// order 중요
export const COMPANY_DETAIL_MENU = {
  COMPANY_SUMMARY: 'company-summary',
  REVIEW: 'company-review',
  INTERVIEW_REVIEW: 'interview-review',
  EMPLOYEE: 'employee',
  SALARY: 'salary',
  SALES: 'sales',
  COMMUNITY: 'community',
} as const;

export const COMPANY_DETAIL_MENU_OBJ_LIST: CompanyDetailMenus[] = [
  {
    id: COMPANY_DETAIL_MENU.COMPANY_SUMMARY,
    text: '기업 요약',
  },
  {
    id: COMPANY_DETAIL_MENU.REVIEW,
    text: '다녀본 리뷰',
  },
  {
    id: COMPANY_DETAIL_MENU.INTERVIEW_REVIEW,
    text: '면접 리뷰',
    isNew: true,
  },
  {
    id: COMPANY_DETAIL_MENU.EMPLOYEE,
    text: '인원',
  },
  {
    id: COMPANY_DETAIL_MENU.SALARY,
    text: '연봉',
  },
  {
    id: COMPANY_DETAIL_MENU.SALES,
    text: '매출',
  },
  {
    id: COMPANY_DETAIL_MENU.COMMUNITY,
    text: 'JOB담',
  },
];

export const COMPANY_DETAIL_MENU_OBJ_LIST_B: CompanyDetailMenus[] = [
  {
    id: COMPANY_DETAIL_MENU.COMPANY_SUMMARY,
    text: '기업 요약',
  },
  {
    id: COMPANY_DETAIL_MENU.REVIEW,
    text: '다녀본 리뷰',
  },
  {
    id: COMPANY_DETAIL_MENU.INTERVIEW_REVIEW,
    text: '면접 리뷰',
    isNew: true,
  },
  {
    id: COMPANY_DETAIL_MENU.EMPLOYEE,
    text: '인원',
  },
  {
    id: COMPANY_DETAIL_MENU.SALARY,
    text: '연봉',
  },
  {
    id: COMPANY_DETAIL_MENU.SALES,
    text: '매출',
  },
];
